// extracted by mini-css-extract-plugin
module.exports = {"Container":"Page_Container___8vZs","DealList":"Page_DealList__QtYL_"};